import { render, staticRenderFns } from "./ProductContainerViewForm.vue?vue&type=template&id=4411775e&"
import script from "./ProductContainerViewForm.vue?vue&type=script&lang=ts&"
export * from "./ProductContainerViewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports